<template>
  <div>
    <div class="view-header">
      <h1>{{$store.state.meta.title}}</h1>
      <div class="func-list">
        <el-button type="primary" plain @click="toList()">导出列表</el-button>
      </div>
    </div>
    <div class="view-div">
      <el-form :model="filterForm" ref="filterForm" size="small" label-suffix=":" :rules="rules" label-width="120px">
        <el-form-item label="导出方式" prop="export_type">
          <el-radio-group v-model="filterForm.export_type">
            <el-radio label="2">PDF</el-radio>
            <el-radio label="1">Excel</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="授权人" prop="template_id1">
          <el-button type="primary" size="small" @click="selectEmpower">选择授权人</el-button>
          <div style="margin-top:10px;">
            <el-tag
              v-for="item in user_ids"
              :key="item.user_id"
              closable
              :style="{marginRight:'5px'}"
              @close="empowerTagClose(item.user_id)"
              type="info">
              {{item.user_name}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="导出时间" prop="export_type">
          <el-radio-group v-model="filterForm.time_type" @change="timeTypeChange">
            <el-radio label="2">提交报告时间</el-radio>
            <el-radio label="1">项目报告时间</el-radio>
          </el-radio-group>
          <el-tooltip class="item" effect="dark" placement="right">
            <div slot="content">
              <ul>
                <li>使用项目报告时间导出时，如项目报告模板中没有时间选择，则无法导出</li>
                <li>如果项目报告模板中有多个时间选择，按第一个日期时间来导出</li>
              </ul>
            </div>
            <i class="el-icon-question" style="font-size: 1.4em;margin-left: 10px;color:#999;"></i>
          </el-tooltip>

        </el-form-item>
        <el-form-item :label="filterForm.time_type==2?'提交报告时间':'项目报告时间'" prop="date">
          <el-date-picker
            v-model="filterForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            @change="dateChange"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目报告名称" prop="template_id">
          <el-checkbox-group v-model="filterForm.template_id">
            <el-row>
              <el-col :span="6" v-for="item of filterList"
                      :style="{marginBottom:'10px'}"
                      :key="item.template_id">
                <el-checkbox
                  :disabled="item.report_num==0"
                  :label="item.template_id">
                  {{item.template_title}}({{item.report_num}}份)
                </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onExport('filterForm')">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <select-empower-dialog ref="selectEmpowerDialog" @save="empowerSave"></select-empower-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import {
  getTemplateList, getReportDateList, getTemplateReportNumber, empowerList, inserExport,
} from '@/api';
import SelectEmpowerDialog from '../../components/SelectEmpowerDialog';

export default {
  name: 'ReportExport',
  components: {
    SelectEmpowerDialog,
  },
  beforeCreate() {
    this.user_id = this.$route.params.user_id;
    this.template_id = this.$route.params.template_id;
  },
  data() {
    const dateValidator = (rule, value, callback) => {
      const [start, end] = value;
      if (moment(`${end} 00:00`) - moment(`${start} 00:00`) > 86400000 * 31) {
        callback('时间范围不能超过31天');
      }
      if (moment(`${end} 00:00`) < moment(`${start} 00:00`)) {
        callback('开始时间不能大于结束时间');
      }
      callback();
    };
    return {
      filterForm: {
        export_type: '2',
        template_id: [],
        date: [],
        time_type:'2'
      },
      rules: {
        template_id: [
          { required: true, message: '请选择项目报告类型' },
        ],
        date: [
          { required: true, message: '请选择提交报告时间' },
          { validator: dateValidator, tiggler: 'change' },
        ],
      },
      filterList: [],
      user_ids: [],
    };
  },
  created() {
    this.filterForm.date = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')];
    if (this.template_id !== '-1') {
      this.filterForm.template_id = [parseInt(this.template_id)];
    }
    if (this.user_id !== '-1') {
      empowerList({ page: -1 }).then((res) => {
        if (res.status === 0) {
          const { data } = res;
          const target = data.filter(item => item.user_id == this.user_id)[0];
          if (target) {
            this.user_ids = [target];
          }
        }
        this._getTemplateList(true);
      });
    }
  },
  methods: {
    dateChange() {
      this._getTemplateList();
    },
    _getTemplateList(isFirst) {
      const filterForm = { ...this.filterForm };
      const userIds = [];
      for (const item of this.user_ids) {
        userIds.push(item.user_id);
      }
      const parameter = {
        user_id: userIds.join(','),
      };
      if (filterForm.date && filterForm.date.length > 0) {
        console.log(filterForm.time_type);
        if(filterForm.time_type==2){
          parameter.start_time = filterForm.date[0];
          parameter.end_time = filterForm.date[1];
        }else{
          parameter.report_start_date = filterForm.date[0];
          parameter.report_end_date = filterForm.date[1];
        }

      }
      if (!isFirst) {
        this.filterForm.template_id = [];
      }
      parameter.is_person = 1

      getTemplateReportNumber(parameter).then((res) => {
        if (res.status === 0) {
          this.filterList = res.data;
          if (isFirst) {
            const target = this.filterList.filter(item => item.template_id == this.filterForm.template_id)[0];
            if (target) {
              if (target.report_num == 0) {
                this.filterForm.template_id = [];
              }
            }
          }
        }
      });
    },
    onExport(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const filterForm = { ...this.filterForm };
          const userIds = [];
          for (const item of this.user_ids) {
            userIds.push(item.user_id);
          }
          if (userIds.length === 0) {
            this.$message.warning("请选择授权人");
            return;
          }
          const parameters = {
            user_ids: userIds,
            template_ids: filterForm.template_id,
            export_type: filterForm.export_type,
          };
          if (filterForm.date && filterForm.date.length > 0) {
            if(filterForm.time_type==2){
              parameters.start_time = filterForm.date[0];
              parameters.end_time = filterForm.date[1];
              parameters.report_start_date = null;
              parameters.report_end_date = null;
            }else{
              parameters.start_time = null;
              parameters.end_time = null;
              parameters.report_start_date = filterForm.date[0];
              parameters.report_end_date = filterForm.date[1];
            }

          }
          inserExport({ param: JSON.stringify(parameters) }).then((res) => {
            if (res.status === 0) {
              const that = this;
              this.$confirm('成功创建导出任务，点击确认进入导出任务列表页，点击取消停留此页面！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                that.$router.push({ name: 'exportList', params: { user_id: this.user_id, template_id: this.template_id } });
              }).catch(() => {

              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    toList() {
      this.$router.push({
        name: 'exportList',
        params: {
          user_id: this.user_id,
        },
      });
    },
    selectEmpower() {
      const { user_ids } = this;

      const ids = [];
      for (const item of user_ids) {
        ids.push(item.user_id);
      }
      this.$refs.selectEmpowerDialog.openDialog(ids);
    },
    empowerSave(list) {
      this.user_ids = [...list];
      this._getTemplateList();
    },
    empowerTagClose(user_id) {
      this.user_ids = this.user_ids.filter(item => item.user_id !== user_id);
    },
    timeTypeChange(){
      this.filterForm.date = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')];

      if(this.filterForm.time_type==2){
        this.rules.date[0].message='请选择提交报告时间'
      }else{
        this.rules.date[0].message='请选择项目报告时间'
      }

      setTimeout(()=>{
        this._getTemplateList();
      })
    }
  },
};
</script>

<style scoped>

</style>
